/* eslint-disable */
import bi1_data_validation from '../../base_i1_datavalidation'
import { RC, CR, AJRS } from '../../base_i2_success_codes'
import base_i3_log from '../../base_i3_logging'
import { ajax } from 'noquery-ajax'

function getNgpEntriesByEntityKey(firebase_email, firebase_token, active_entries,acknowledged_entries,
  manual_history_entries,manual_active_entries, lookup_data = {}) {
  return new Promise(function (resolve, reject) {
    var return_msg = "";
    var debug_data = [];
    var call_result = {};
    var task_id = "p2s7t18getNgpEntriesByEntityKey";
    var updated_entries = {};

    let debug_index = 0;
    ///// input validation
    
    call_result = bi1_data_validation.is_email_address(firebase_email);
    debug_data.push(call_result);
    call_result = bi1_data_validation.is_string(firebase_token);
    debug_data.push(call_result);
    call_result = bi1_data_validation.is_array(active_entries);
    debug_data.push(call_result);
    call_result = bi1_data_validation.is_array(acknowledged_entries);
    debug_data.push(call_result);
    call_result = bi1_data_validation.is_array(manual_history_entries);
    debug_data.push(call_result);
    call_result = bi1_data_validation.is_array(manual_active_entries);
    debug_data.push(call_result);
   
    var validation_failed_flag = false;
    for (var index in debug_data) {
      if (debug_data[index][CR.success] != RC.success) {
        validation_failed_flag = true;
        break;
      }
    }
    
    if (validation_failed_flag == true) {
      return_msg += "input validation failed";
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      reject({ success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data,
         updated_entries: updated_entries, lookup_data: lookup_data});
    }
    /////</end> input validation

    var params = {
      'p2s7_firebase_email': firebase_email,
      'p2s7_token': firebase_token,
      'p2s7t18_active_keys': JSON.stringify(active_entries),
      'p2s7t18_acknowledged_keys': JSON.stringify(acknowledged_entries),
      'p2s7t18_manual_history_keys': JSON.stringify(manual_history_entries),
      'p2s7t18_manual_active_keys': JSON.stringify(manual_active_entries)
    }

    ajax({
      url: window.G_ajax_test_domain + '/json-requests/p2s7t18-get-notification-group-entries-by-key',
      method: 'POST',
      data: params, 
      success: function (result) {
        updated_entries = result;
        resolve({ success: RC.general_failure, return_msg: return_msg, debug_data: debug_data,
           updated_entries: updated_entries, lookup_data: lookup_data});
      },
      error: function (err) {

        if (err.status == 401) {
          window.G_firebase_auth.bi5forceTokenRefresh();
        }
        return_msg += "Failed to get notification group entries data, error data:" + JSON.stringify(err);
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.ajax_failure, return_msg, debug_data);
        reject({ success: RC.general_failure, return_msg: return_msg, debug_data: debug_data,
           updated_entries: updated_entries, lookup_data: lookup_data});
      }
    })

  });
};

export default getNgpEntriesByEntityKey 



// WEBPACK FOOTER //
// ./src/watchdog_includes/json_tasks/p2s7/p2s7t18.js